import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxWidth: 16,
  viewboxHeight: 16,
};

const ArrowForwardOutlineIcon = ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      viewboxHeight={viewboxHeight}
      viewboxWidth={viewboxWidth}
      {...rest}
    >
      <g>
        <path
          d="M1.371 14.983a1.292 1.292 0 0 1-.765-.24 1.349 1.349 0 0 1-.537-1.555c1.074-3.017 2.217-8.697 7.828-9.085a.286.286 0 0 0 .263-.286V2.388a1.371 1.371 0 0 1 2.286-.971l5.108 5.109a1.371 1.371 0 0 1 0 1.885l-5.017 5.612a1.36 1.36 0 0 1-2.139-.153 1.382 1.382 0 0 1-.238-.773v-1.394a.263.263 0 0 0-.175-.264.252.252 0 0 0-.11-.01c-2.035 0-2.56.594-4.48 2.285l-1.144.971c-.248.201-.56.307-.88.298ZM8.514 5.84c-3.783 0-5.223 3.051-6.125 5.714a.286.286 0 0 0 .102.332.297.297 0 0 0 .355 0C4.64 10.286 5.714 9.69 8 9.69h.766a1.143 1.143 0 0 1 1.143 1.143v.594a.286.286 0 0 0 .502.195L14 7.668a.297.297 0 0 0 0-.4l-3.634-3.554a.308.308 0 0 0-.309-.068.286.286 0 0 0-.183.274v.766a1.143 1.143 0 0 1-1.143 1.142l-.217.012Z"
          fill="currentColor"
        />
      </g>
    </SVGLoader>
  );
};

export default ArrowForwardOutlineIcon;
